import styled from 'styled-components';

export const MainWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 70%, rgba(30, 136, 229, 0.06) 0%, transparent 50%),
                radial-gradient(circle at 70% 30%, rgba(255, 193, 7, 0.06) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const PlanoHeader = styled.div`
  margin-bottom: 2rem;
  position: relative;
`;

export const StatusBadge = styled.div`
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 2;
  
  ${props => {
    switch (props.status) {
      case 'aprovado':
        return `
          background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
          color: white;
        `;
      case 'pendente':
        return `
          background: linear-gradient(135deg, #ed8936 0%, #dd6b20 100%);
          color: white;
        `;
      case 'reembolsado':
        return `
          background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
          color: white;
        `;
      case 'recusado':
        return `
          background: linear-gradient(135deg, #c53030 0%, #9b2c2c 100%);
          color: white;
        `;
      default:
        return `
          background: linear-gradient(135deg, #718096 0%, #4a5568 100%);
          color: white;
        `;
    }
  }}
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    padding: 0.4rem 0.8rem;
    top: -8px;
    right: -8px;
  }
`;

export const MainContent = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 6rem 2rem;
  position: relative;
  z-index: 1;
  text-align: center;
`;

export const PageHeader = styled.div`
  margin-bottom: 4rem;
`;

export const PageTitle = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(135deg, #1e88e5 0%, #1976d2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.5px;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.2rem;
  color: #4a5568;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
  font-weight: 400;
`;

export const PlanosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  max-width: 1600px;
  margin: 0 auto;
  
  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const PlanoCard = styled.div`
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08), 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.8);
  overflow: hidden;
  min-height: 450px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #1e88e5 0%, #ffc107 100%);
    transform: scaleX(0);
    transition: transform 0.4s ease;
  }
  
  ${props => props.destaque && `
    background: linear-gradient(135deg, #1E88E5 0%, #1976d2 100%);
    color: white;
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(30, 136, 229, 0.3), 0 8px 20px rgba(0, 0, 0, 0.1);

    &::after {
      content: 'MAIS POPULAR';
      position: absolute;
      top: 40px;
      right: -40px;
      background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
      color: #2d3748;
      padding: 8px 40px;
      font-size: 0.8rem;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 1px;
      transform: rotate(45deg);
      box-shadow: 0 4px 15px rgba(255, 193, 7, 0.4);
      z-index: 10;
      border-radius: 4px;
    }
    
    
    &::before {
      background: linear-gradient(90deg, #ffc107 0%, #ff9800 100%);
      transform: scaleX(1);
    }
    
    h3, p, div {
      color: white;
    }
    
    ${PlanoTipo} {
      color: white !important;
      background: none !important;
      -webkit-text-fill-color: white !important;
    }
    
    ${PlanoPreco} {
      background: rgba(255, 255, 255, 0.15);
      border: 2px solid rgba(255, 255, 255, 0.3);
      
      ${PrecoValor} {
        color: rgb(255, 255, 255) !important;
        font-size: 2.2rem;
        background: none !important;
        -webkit-text-fill-color: white !important;
      }
      
      ${PrecoTotal} {
        color: rgb(255, 255, 255);
      }
    }
    
    button {
      background: white !important;
      color: #1E88E5 !important;
      
      &:hover {
        background: #f8f9fa !important;
        color: #1976d2 !important;
        transform: translateY(-2px) scale(1.05) !important;
      }
    }
  `}
  
  &:hover {
    transform: translateY(-8px) ${props => props.destaque ? 'scale(1.05)' : 'scale(1.02)'};
    box-shadow: ${props => props.destaque ? '0 20px 50px rgba(30, 136, 229, 0.4), 0 10px 25px rgba(0, 0, 0, 0.15)' : '0 15px 35px rgba(0, 0, 0, 0.12), 0 8px 20px rgba(0, 0, 0, 0.08)'};
    
    &::before {
      transform: scaleX(1);
    }
  }
`;

export const PlanoTipo = styled.h3`
  font-size: 1.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: -0.3px;
  line-height: 1.2;
`;

export const PlanoDescricao = styled.p`
  font-size: 0.9rem;
  color: #4a5568;
  text-transform: uppercase;
  font-weight: 600;
`;

export const PlanoPreco = styled.div`
  text-align: center;
  margin: 1.5rem 0;
  padding: 2rem 1.5rem;
  background: linear-gradient(145deg, #f8f9fa 0%, #edf2f7 100%);
  border-radius: 16px;
  border: 2px solid rgba(233, 236, 239, 0.6);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(30, 136, 229, 0.03) 0%, rgba(255, 193, 7, 0.03) 100%);
    pointer-events: none;
  }
`;

export const PrecoValor = styled.div`
  font-size: 2.2rem;
  font-weight: 900;
  background: linear-gradient(135deg, #1E88E5 0%, #1976d2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
`;

export const PrecoTotal = styled.div`
  font-size: 1rem;
  color: #6c757d;
  font-weight: 600;
  position: relative;
  z-index: 1;
  opacity: 0.8;
`;

export const PlanoFeatures = styled.div`
  margin-bottom: 2rem;
  text-align: left;
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #4a5568;
  margin-bottom: 1rem;
  padding: 0.25rem 0;
  font-weight: 500;
  line-height: 1.5;
  transition: all 0.3s ease;
  
  &::before {
    content: '✓';
    background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
    color: white;
    font-weight: bold;
    margin-right: 1rem;
    font-size: 0.8rem;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);
  }
  
  &:hover {
    color: #2d3748;
    transform: translateX(4px);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const PlanoButton = styled.button`
  background: linear-gradient(135deg, #1E88E5 0%, #1976d2 100%);
  color: white;
  border: none;
  padding: 1.2rem 2rem;
  border-radius: 15px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  width: 100%;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(30, 136, 229, 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 25px rgba(30, 136, 229, 0.4), 0 4px 12px rgba(0, 0, 0, 0.1);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0 4px 15px rgba(30, 136, 229, 0.3);
  }
`;